import { Injectable } from '@angular/core';
import { CouponType, IsCouponValidGQL, IsCouponValidType, RedeemCouponGQL } from '@sifca-monorepo/ecommerce-generator';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CouponService {
  // Private
  private coupon: BehaviorSubject<CouponType | null> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(
    private isCouponValidGQL: IsCouponValidGQL,
    private redeemCouponGQL: RedeemCouponGQL,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for slides
   */
  get coupon$(): Observable<CouponType> {
    return this.coupon.asObservable();
  }

  isCouponValid(pos: string, couponCode: string): Observable<IsCouponValidType> {
    return this.isCouponValidGQL
      .fetch({
        couponCode,
        target: { pos },
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.isCouponValid;
          }
        }),
      );
  }

  redeemCoupon(pos: string, couponCode: string): Observable<CouponType> {
    return this.redeemCouponGQL
      .mutate({
        couponCode,
        target: { pos },
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.redeemCoupon;
          }
        }),
      );
  }
}
